<template>
  <div>
    <el-dialog
      :visible.sync="dialsetting"
      width="80%"
      title="历史记录">
        <el-table :data="historyList" border>
            <el-table-column class="data-table" label="币种" prop="coinType"></el-table-column>
            <el-table-column class="data-table" label="手续费模式" prop="withdrawFeeType">
              <template slot-scope="scope">
                {{scope.row.withdrawFeeType == '0'?'模式一':'模式二'}}
              </template>
            </el-table-column>
            <el-table-column class="data-table" label="手续费" prop="withdrawFee"></el-table-column>
            <el-table-column class="data-table" label="精度">
              <template slot-scope="scope">
                {{scope.row.withdrawFeeType == "0"?'--':scope.row.costPrecision}}
              </template>
            </el-table-column>
            <el-table-column class="data-table" label="提现成本（USDT）">
              <template slot-scope="scope">
                {{scope.row.withdrawFeeType == "0"?'--':scope.row.cost}}
              </template>
            </el-table-column>
            <el-table-column class="data-table" label="币种价格（USDT）" >
              <template slot-scope="scope">
                {{scope.row.withdrawFeeType == "0"?'--':scope.row.coinPrice}}
              </template>
            </el-table-column>
            <el-table-column class="data-table" label="时间" prop="createTime"></el-table-column>
        </el-table>
        <el-pagination style="margin-top: 30px"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="paginations.page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="paginations.size"
      layout="total, sizes, prev, pager, next, jumper"
        :total="historyTotal">
    </el-pagination>   
    </el-dialog>
  </div>
</template>
<script>
import '../store.js';
import Pagination from "../../../components/pagination";
import { mapState,mapActions } from 'vuex';
import {SHARE_TYPE} from '../constant.js'
import moment from 'moment'; 
export default {
  name: "batchsetting",
  components: {
    Pagination
  },
  data() {
    return {
        cycleList:[{a:1,b:2,c:3,d:4,f:5,g:6}],
       dialsetting:false,
       paginations: {
        page: 1,
        size: 10
      },
      id:null
    };
  },
  methods: {
    ...mapActions('withdrawal', ['getOfficeList']),
    showData(id) {
        this.dialsetting = true
        this.id = id;
        this.getOfficeList({withdrawFeeConfigId:id,opSourceType:-1,...this.paginations})
    },
    handleSizeChange(val) {
        this.paginations.size = val;
        this.getOfficeList({withdrawFeeConfigId:this.id,opSourceType:-1,...this.paginations})
    },
    handleCurrentChange(val) {
        this.paginations.page = val;
        this.getOfficeList({withdrawFeeConfigId:this.id,opSourceType:-1,...this.paginations})
    },
  },
  computed: {
    ...mapState('withdrawal', ['pagination','historyList','historyTotal']),
  },
  watch: {
  },
  filters: {
  },
};
</script>
<style lang="less" scoped>
  
</style>
